import {Component} from '@angular/core';
import {lastValueFrom} from "rxjs";
import { dateFormat } from '@core/_utils/date.utils';
import { TranslateService } from '@ngx-translate/core';
import { getFileNameWithoutExt } from '@core/_utils/tools.utils';
import { ApiV6Service } from '@service/apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import {DownloadService} from "@service/download.service";

@Component({
    selector: 'page-logs',
    templateUrl: './page-logs.component.html',
    styleUrls: ['./page-logs.component.scss']
})
export class PageLogsComponent {

    public logs: any;
    public visible: any;
    public data: any;
    public file: string = '';

    constructor(public api: ApiV6Service, public translate: TranslateService,protected _messageService: MessagesService,
                private downloadService: DownloadService)
    {
        this.getFileList();
    }

    private async getFileList() {
        try {
            this.logs = await lastValueFrom(this.api.execUrlAction('getlogs', ''));
            this.logs = this.logs.map((item) => {
                item.file_date = item.file_date + '|' + dateFormat(item.file_date, 'dd/MM/yyyy HH:mm:ss');
                return item;
            });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    public async open_log_file($event) {
        if ($event.option !== null) {
            this.file = $event.option.file_name;
            try {                
                this.data = await lastValueFrom(this.api.execUrlAction('readlog', {file: this.file}));
                this.data = this.data.map((item) => {
                    item.datetime = item.datetime + '|' + dateFormat(item.datetime, 'dd/MM/yyyy HH:mm:ss');
                    return item;
                });
            } catch (error) {
                console.log('Error', error);
                this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            }
        }
    }

    public async exportExcel() {
        await this.downloadService.exportExcel(getFileNameWithoutExt(this.file), this.data);
    }
}
